export const LIST_DEPOSITS = "LIST_DEPOSITS";

export const DEPOSIT_WITHDRAW = "DEPOSIT_WITHDRAW";